import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  menu: any[] = [
    {
      title: 'Home',
      url: 'hero',
    },
    {
      title: 'About',
      url: 'about',
    },
    {
      title: 'Resume',
      url: 'resume',
    },
    {
      title: 'Services',
      url: 'services',
    },
    {
      title: 'Portafolio',
      url: 'portfolio',
    },
    {
      title: 'Contact',
      url: 'contact',
    }
  ];

  constructor() { }
}
